module.exports = __webpack_public_path__ + "img/9.4abd8cc4.png";